import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Raffles from './pages/Raffles';
import RaffleDetail from './pages/RaffleDetail';
import CreateRaffle from './pages/CreateRaffle';
import MyRaffles from './pages/MyRaffles';
import Admin from './pages/Admin';
import ManageRaffle from './pages/ManageRaffle';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Contact from './pages/Contact';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import CookieConsent from './components/CookieConsent';
import './i18n';
import './styles/App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Navbar />
          <main style={{ minHeight: 'calc(100vh - 140px)' }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/raffles" element={<Raffles />} />
              {/* Slug-based raffle URL (primary) */}
              <Route path="/rifa/:slug" element={<RaffleDetail />} />
              {/* Legacy ID-based URL (still works) */}
              <Route path="/raffle/:id" element={<RaffleDetail />} />
              <Route path="/manage/:id" element={<ProtectedRoute><ManageRaffle /></ProtectedRoute>} />
              <Route path="/create" element={<ProtectedRoute><CreateRaffle /></ProtectedRoute>} />
              <Route path="/my-raffles" element={<ProtectedRoute><MyRaffles /></ProtectedRoute>} />
              <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <CookieConsent />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
